import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { MediaList } from './internalComponents/MediaList';

interface State {
}

interface Props {
}

/**
 * ce composant permet l'affichage de la page des medias
 */
export class MediasPage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                    UserRole.USER,
                ]}
            >
                <MediaList/>
            </PageChorinitia>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/MediasPage/MediasPage.tsx